import React from 'react'
import AccessibilityIcon from '@aok/icon-accessibility'
import LinearIcon from '@aok/icon-linear'

const LinearIconHelper = (props) => {
  const { name } = props

  switch (name) {
    case 'accessible-website':
    case 'acoustic-signals':
    case 'assistance-dog':
    case 'automatic-entrance-door':
    case 'barrier-free-accessibility':
    case 'braille':
    case 'building-plan-braille':
    case 'communication-aids':
    case 'dementia':
    case 'easy-language':
    case 'elevator-braille':
    case 'elevator-seat':
    case 'elevator-visual-display':
    case 'elevator-voice-announcement':
    case 'elevator-wheelchair-accessible':
    case 'emergency-call-systems-wheelchair-accessible':
    case 'guide-system-for-the-blind':
    case 'hearing-impairment':
    case 'help-dementia':
    case 'help-mobility':
    case 'help-visual-impairment':
    case 'high-contrast-labeling':
    case 'light-signals':
    case 'medial-offers':
    case 'no-stairs':
    case 'parking-wheelchair-accessible':
    case 'pictograms':
    case 'religious-spiritual-reflection-1':
    case 'religious-spiritual-reflection-2':
    case 'room-braille':
    case 'room-signaling-systems':
    case 'room-visual-display':
    case 'sanitary-facilities-wheelchair-accessible':
    case 'sign-language-interpreter':
    case 'visual-impairment':
    case 'waiting-area-visual-display':
    case 'wc-genderfree':
    case 'wc-wheelchair-accessible':
      return <AccessibilityIcon {...props} />

    default:
      return <LinearIcon {...props} />
  }
}

export default LinearIconHelper
